module.exports = __webpack_public_path__ + "img/environment_bed.350def55.jpg";